import { useState } from 'react';
import { Card, Button, Textarea } from '../shared';
import './ForecastForm.css';

function ForecastForm({ onSubmit }) {
  const [question, setQuestion] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleChange = (value) => {
    setQuestion(value);
    setError(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const text = question.trim();

    if (text.length < 10) {
      setError('Question must be at least 10 characters');
      return;
    }

    if (text.length > 500) {
      setError('Question must be less than 500 characters');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      await onSubmit(text);
    } catch (err) {
      setError(err.message || 'Failed to create forecast');
      setLoading(false);
    }
  };

  return (
    <div className="forecast-form">
      <Card title="Submit Question">
        <form onSubmit={handleSubmit} className="forecast-form__form">
          <Textarea
            value={question}
            onChange={handleChange}
            placeholder="Will X happen by Y date?"
            label="Your Question"
            rows={4}
            disabled={loading}
            error={error}
            maxLength={500}
            showCounter
          />

          <div className="forecast-form__actions">
            <Button
              type="submit"
              variant="primary"
              disabled={!question.trim()}
              loading={loading}
            >
              Generate Forecast
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}

export default ForecastForm;
